export default __webpack_public_path__ + "static/media/icon_google-play.2dc67ffd-2.b3f3ecf5.svg";